<template>

    <ion-item>
        <div :class="'svg-wrapper svg-color-'+color">
            <svg class="voxion"><use :xlink:href="'#icon-'+icon"></use></svg>
        </div>
        <ion-label><div class="h6">{{title}}</div><p v-if="excerpt">{{excerpt}}</p></ion-label>

        <div v-if="isBlockedForAnotherAnswer !== true" class="action-group">
            <ion-anchor v-if="type == 'active'" color="secondary"><router-link :to="{ name: 'QuestionSingle', params: { slug: slug }}">Odpowiedz</router-link></ion-anchor>
            <ion-anchor v-if="type == 'wrong' && Boolean(secondChance) == true" color="danger"><router-link :to="{ name: 'QuestionSingle', params: { slug: slug }}">Spróbuj jeszcze raz</router-link></ion-anchor>
        </div>
    </ion-item>

</template>

<script>
    export default {
        name: 'ItemQuestion',
        props: {
            data : {
                type: [Array, Object],
                required : true
            }
        },
        computed: {
            slug(){
                return this.data.slug;
            },
            type(){
                let type = 'active';
                /*if(this.isBlockedForAnotherAnswer == true){
                    type = null;
                    return type;
                }*/
                if(this.isCorrectAnswer != null) {
                    if (Boolean(this.isCorrectAnswer) === true) {
                        type = 'correct';
                    } else {
                        type = 'wrong';
                    }
                }
                return type;
            },
            isCorrectAnswer(){
                return this.data.isCorrectAnswer;
            },
            isBlockedForAnotherAnswer(){
                return this.data.isBlockedForAnotherAnswer;
            },
            secondChance(){
                return this.type == 'wrong' && this.isBlockedForAnotherAnswer == true ? false : true;
            },
            color(){
                let color  = 'secondary';
                if(this.isBlockedForAnotherAnswer == true){
                    color  = 'gray'
                }
                if(this.type == 'wrong'){
                    color = 'danger'
                }
                if(this.type == 'correct'){
                    color = 'success'
                }
                return color;
            },
            icon(){
                let icon  = 'hint';
                if(this.type == 'wrong'){
                    icon = 'sad-face'
                }
                if(this.type == 'correct'){
                    icon = 'cheerful-face'
                }
                return icon;
            },
            title(){
                return this.data.title;
            },
            excerpt(){
//                return '('+this.isCorrectAnswer+' | '+this.isBlockedForAnotherAnswer+') =< '+this.type+' '+this.secondChance +' ## '+this.data.type
                return this.data.excerpt ? this.data.excerpt : null;
            }
        }
    }
</script>

<style lang="scss" scoped>

    ion-item{
        --padding-start: 0;
        --padding-end: 0;
        --inner-padding-start: 0;
        --inner-padding-end: 0;

    }

    ion-label {
        white-space: normal !important;
        text-overflow: clip;
        padding-right: 12px;
    }
    
    

    ion-anchor {
        @media(max-width: 480px){
            font-size: 14px;
            max-width: 70px;
            text-align: right;
            word-wrap: normal;
            white-space: normal !important;
        }
    }

</style>